module.exports = __webpack_public_path__ + "img/aq.fffeece3.png";